import { jsx as _jsx } from "react/jsx-runtime";
import { PureComponent } from "react";
import IntegrationsSlider from "./components/integrations-slider/integrations-slider-component";
import { duplicateBadges } from "./integrationBadges";
import { StyledFloatingIntegrationsComponent } from "./floating-integrations-component.scss";
class FloatingIntegrationsComponent extends PureComponent {
    render() {
        return /*#__PURE__*/ _jsx(StyledFloatingIntegrationsComponent, {
            className: "floating-integrations-component",
            children: /*#__PURE__*/ _jsx(IntegrationsSlider, {
                integrationBadges: duplicateBadges()
            })
        });
    }
}
export { FloatingIntegrationsComponent as default };
